import React, { useEffect, useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { greyScaleColour } from "@tphglobal/common/theme/style.palette";
import { DailyTime } from "../../../models";
import { truncateText } from "../../../utils/commonFunctions";

interface Props {
  setWeekData: (update: (weekData: DailyTime[]) => DailyTime[]) => void;
  fieldKey: keyof DailyTime;
  rowIndex: number;
  value?: string;
  readOnly?: boolean;
}

const TextInputField: React.FC<Props> = ({
  setWeekData,
  fieldKey,
  rowIndex,
  value,
  readOnly = false,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState<string>(value);

  const handleClick = () => {
    if (readOnly) return;
    setIsEditing(true);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (readOnly) return;
    setInputValue(event.target.value);
    setWeekData((prevWeekData: DailyTime[]) => {
      const newWeekData: DailyTime[] = [...prevWeekData];

      if (newWeekData[rowIndex]) {
        newWeekData[rowIndex] = {
          ...newWeekData[rowIndex],
          [fieldKey]: event.target.value,
        };
      }

      return newWeekData;
    });
  };

  const handleClickAway = () => {
    if (isEditing) {
      setIsEditing(false);
    }
  };
  const showInput = isEditing && !readOnly;

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        position="relative"
        display="inline-block"
        sx={{
          width: "100%",
          maxWidth: "100%",
        }}
      >
        {showInput ? (
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            onBlur={() => setIsEditing(false)}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            style={{
              border: "none",
              width: "100%",
              backgroundColor: "transparent",
            }}
          />
        ) : (
          <Tooltip title={inputValue || ""} arrow placement="top">
            <span>
              <Box
                component="span"
                onClick={handleClick}
                sx={{
                  cursor: readOnly ? "default" : "pointer",
                  color: greyScaleColour?.grey100,
                  opacity: readOnly ? 0.7 : 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",

                  ["@media (max-width:900px)"]: {
                    whiteSpace: "normal",
                    overflow: "visible",
                    textOverflow: "unset",
                    wordBreak: "break-word",
                  },
                }}
              >
                {truncateText(inputValue, 30)}
              </Box>
            </span>
          </Tooltip>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default TextInputField;
